"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.HeroShadowbox = void 0;
require("./HeroShadowbox.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionFormatter = require("../../util/actionFormatter/actionFormatter");
var _conditionalAttributes = require("../../util/conditionalAttributes/conditionalAttributes");
var _getButtonHtml = require("../../util/getButtonHtml/getButtonHtml");
var _getLinkHtml = require("../../util/getLinkHtml/getLinkHtml");
var _renderObject = require("../../util/renderObject/renderObject");
var _GridContainer = _interopRequireDefault(require("../GridContainer/GridContainer"));
var _HeroBody = _interopRequireDefault(require("../HeroBody/HeroBody"));
var _HeroFooter = _interopRequireDefault(require("../HeroFooter/HeroFooter"));
var _HeroHeader = _interopRequireDefault(require("../HeroHeader/HeroHeader"));
var _Image = _interopRequireDefault(require("../Image/Image"));
var _LoaderGhostCard = _interopRequireDefault(require("../LoaderGhostCard/LoaderGhostCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Represents a HeroShadowbox component
 *
 * @method
 * @param {HeroShadowboxProps} props
 * @returns HeroShadowbox
 */

const HeroShadowbox = props => {
  const {
    actionGroups,
    backgroundColor = defaultProps.backgroundColor,
    body,
    externalAction,
    externalActionFullyClick,
    externalMedia,
    externalThumbnailImage,
    eyebrow,
    footerStyle,
    fullyClickableParent,
    headline,
    headlineTag = defaultProps.headlineTag,
    image,
    shadowColor,
    style = defaultProps.style,
    tag,
    thumbnailImage,
    theme = defaultProps.theme,
    /* loading state props */
    isLoading = defaultProps.isLoading,
    loaderHeightXl,
    loaderHeightLg,
    loaderHeightMd,
    loaderHeightSm
  } = props;
  let formattedActionFullyClick;
  const hasShadowBox = style === 'default' || style === 'expanded';
  const hasBackgroundColor = hasShadowBox && backgroundColor;
  const hasText = body || eyebrow || headline || actionGroups || tag;
  const hasImage = image || externalMedia;
  const hasThumbnail = (thumbnailImage || externalThumbnailImage) && style === 'expanded';
  const paletteOneAction = actionGroups && actionGroups.actions?.length === 1;
  const hasOneAction = fullyClickableParent || paletteOneAction;
  if (paletteOneAction) {
    formattedActionFullyClick = (0, _actionFormatter.actionFormatter)({
      action: actionGroups?.actions[0],
      types: actionGroups?.types,
      hasOneAction: hasOneAction,
      derivedAriaLabel: actionGroups?.actions[0].label,
      fullyClickableParent: paletteOneAction
    }, {
      getButtonMarkup: _getButtonHtml.getButtonHtml,
      getLinkMarkup: _getLinkHtml.getLinkHtml
    });
  }
  const componentClassName = (0, _classnames.default)('pal-c-HeroShadowbox', {
    'pal-c-HeroShadowbox--backgroundColor': hasBackgroundColor,
    [`pal-c-HeroShadowbox--${style}`]: style,
    [`pal-c-HeroShadowbox--oneAction`]: hasOneAction
  });
  const componentStyle = {
    '--backgroundColor': `var( --pal-colors-${theme}-${backgroundColor} )`,
    ...(0, _conditionalAttributes.conditionalAttributes)(isLoading ? {
      '--backgroundColor': 'var(--pal-color-opacity-transparent)',
      '--pal-loaderghost-card-height-xl': loaderHeightXl,
      '--pal-loaderghost-card-height-lg': loaderHeightLg,
      '--pal-loaderghost-card-height-md': loaderHeightMd,
      '--pal-loaderghost-card-height-sm': loaderHeightSm
    } : null)
  };
  const componentClassNameBox = (0, _classnames.default)('pal-c-HeroShadowbox__colorBox', {
    'pal-c-HeroShadowbox__colorBox--backgroundColor': shadowColor
  });
  const shadowStyle = {
    '--backgroundColor': isLoading ? 'var(--pal-color-opacity-transparent)' : `var( --pal-colors-${theme}-${shadowColor} )`
  };
  const heroContent = () => {
    if (isLoading) {
      return /*#__PURE__*/_react.default.createElement(_LoaderGhostCard.default, {
        className: "pal-c-HeroShadowbox__loader",
        variant: "default"
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasOneAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(formattedActionFullyClick)), externalActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalActionFullyClick))), hasImage && /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-HeroShadowbox__image"
      }, /*#__PURE__*/_react.default.createElement(_HeroHeader.default, {
        externalMedia: externalMedia,
        image: {
          desktopImage: image?.image,
          tabletImage: image?.tabletImage,
          mobileImage: image?.mobileImage,
          altText: image?.altText,
          loading: image?.loading
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-HeroShadowbox__mainContainer"
      }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, hasThumbnail && /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-HeroShadowbox__thumbnailImage"
      }, externalThumbnailImage && (0, _renderObject.renderObject)(externalThumbnailImage), !externalThumbnailImage && /*#__PURE__*/_react.default.createElement(_Image.default, {
        desktopImage: thumbnailImage?.image,
        externalMedia: externalThumbnailImage,
        ratio: thumbnailImage?.ratio
      })), hasText && /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-HeroShadowbox__bodyAndAction"
      }, /*#__PURE__*/_react.default.createElement(_HeroBody.default, {
        textPosition: "center",
        tag: tag,
        eyebrow: eyebrow,
        headline: headline,
        headlineStyle: "headline",
        headlineTag: headlineTag,
        body: body,
        bodyStyle: "body-xlg",
        textAlign: "center"
      }), /*#__PURE__*/_react.default.createElement(_HeroFooter.default, _extends({}, actionGroups, {
        externalAction: externalAction,
        alignment: "center",
        style: footerStyle
      }))), hasShadowBox && /*#__PURE__*/_react.default.createElement("div", {
        className: componentClassNameBox,
        style: shadowStyle
      }))));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    style: componentStyle
  }, heroContent());
};

/**
 * Property type definitions
 * @typedef HeroShadowboxProps
 * @type {object}
 * @property {object} actionGroups - Allows passing an object to the actionGroups prop
 * @property {string} backgroundColor - color for the background on SM viewports
 * @property {string} body - body text/description of the hero body
 * @property {object} externalAction - external action object
 * @property {object} externalImage - brings in the UltaAsset
 * @property {string} eyebrow - smaller text above the title
 * @property {string} footerStyle - style for footer
 * @property {string} headline - headline text of the hero body
 * @property {string} headlineTag - headline tag of the hero body
 * @property {object} image - desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
 * @property {string} shadowColor - color for the shadowbox
 * @property {string} style - sets the type of shadowbox hero
 * @property {object} tag - tag component above the eyebrow
 * @property {string} theme -  theme: 'default' - sets the theme at the component level
 * @property {object} thumbnailImage - desktopImage, and ratio for Image component
 * @property {boolean} isLoading - sets the loading state for the hero
 * @property {string} loaderHeightSm - Accepts the height of the loader for small viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightMd - Accepts the height of the loader for medium viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightLg - Accepts the height of the loader for large viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightXl - Accepts the height of the loader for xLarge viewport( e.g. "32.2rem" )
 */
exports.HeroShadowbox = HeroShadowbox;
const propTypes = exports.propTypes = {
  /**
   * Allows passing an object to the actionGroups prop
   */
  actionGroups: _propTypes.default.object,
  /**
   * Color for the background
   */
  backgroundColor: _propTypes.default.oneOf(['background-default', 'background-brand-01', 'background-brand-02', 'background-brand-03', 'background-brand-04', 'background-xsubtle']),
  /**
   * body text/description of the hero body
   */
  body: _propTypes.default.string,
  /**
   * desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
   */
  eyebrow: _propTypes.default.string,
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Brings in the UltaAsset
   */
  externalImage: _propTypes.default.object,
  /**
   * style for footer
   */
  footerStyle: _propTypes.default.string,
  /**
   * headline text of the hero body
   */
  headline: _propTypes.default.string,
  /**
   * HTML tag for the headline
   */
  headlineTag: _propTypes.default.string,
  /**
   * Allows passing an object to the primaryAction prop
   */
  image: _propTypes.default.object,
  /**
   * Color for the shadowbox
   */
  shadowColor: _propTypes.default.oneOf(['background-brand-02-knockout', 'background-brand-04-knockout', 'background-brand-01-xstrong', 'background-brand-02-xstrong', 'background-brand-03-xstrong', 'background-brand-04-xstrong', '']),
  /**
   * sets the type of shadowbox hero - oneOf('default', 'expanded', 'collapsed')
   */
  style: _propTypes.default.oneOf(['default', 'expanded', 'collapsed']),
  /**
   * tag component above the eyebrow
   */
  tag: _propTypes.default.object,
  /**
   * Sets the theme
   */
  theme: _propTypes.default.string,
  /**
   * thumbnailImage, and ratio for Image component
   */
  thumbnailImage: _propTypes.default.object,
  /**
   * Sets the loading state of the hero
   */
  isLoading: _propTypes.default.bool,
  /**
   * Accepts the height of the loader for small viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightSm: _propTypes.default.string,
  /**
   * Accepts the height of the loader for medium viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightMd: _propTypes.default.string,
  /**
   * Accepts the height of the loader for large viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightLg: _propTypes.default.string,
  /**
   * Accepts the height of the loader for Xlarge viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightXl: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} backgroundColor - sets the background color
 * @property {string} headlineTag - headlineTag: 'h2' - sets the default for the headline tag
 * @property {string} theme -  theme: 'default' - sets the theme at the component level
 * @property {string} style - style: 'default' - sets the type of shadowbox hero
 * @property {boolean} isLoading - isLoading: false - sets the default loading state to false
 */
const defaultProps = exports.defaultProps = {
  backgroundColor: 'background-default',
  headlineTag: 'h2',
  theme: 'default',
  style: 'default',
  isLoading: false
};
HeroShadowbox.propTypes = propTypes;
var _default = exports.default = HeroShadowbox;